import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TroubleSigningInPageComponent } from './pages/trouble-signing-in-page/trouble-signing-in-page.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ForgotUsernameComponent } from './components/forgot-username/forgot-username.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { SendConfirmationCodeByEmailComponent } from './components/forgot-password/send-confirmation-code-by-email/send-confirmation-code-by-email.component';
import { SendConfirmationCodeByPhoneComponent } from './components/forgot-password/send-confirmation-code-by-phone/send-confirmation-code-by-phone.component';
import { VerifyConfirmationCodeByPhoneComponent } from './components/forgot-password/send-confirmation-code-by-phone/verify-confirmation-code-by-phone/verify-confirmation-code-by-phone.component';
import { VerifyConfirmationCodeByEmailComponent } from './components/forgot-password/send-confirmation-code-by-email/verify-confirmation-code-by-email/verify-confirmation-code-by-email.component';
import { SubmitConfirmationCodeFormComponent } from './components/forgot-password/submit-confirmation-code-form/submit-confirmation-code-form.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { VerifyEmailComponent } from './components/verify-email/verify-email/verify-email.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [
    TroubleSigningInPageComponent,
    ForgotPasswordComponent,
    ForgotUsernameComponent,
    SendConfirmationCodeByEmailComponent,
    SendConfirmationCodeByPhoneComponent,
    VerifyConfirmationCodeByPhoneComponent,
    VerifyConfirmationCodeByEmailComponent,
    SubmitConfirmationCodeFormComponent,
    VerifyEmailComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxMaskModule.forRoot()
  ]
})
export class TroubleSigningInModule { }
